import { render, staticRenderFns } from "./ReceiptDetailFooter.vue?vue&type=template&id=1dfc15b4&scoped=true&"
import script from "./ReceiptDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./ReceiptDetailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptDetailFooter.vue?vue&type=style&index=0&id=1dfc15b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc15b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow,VSpacer})
